import React, { Fragment, useRef, useState, useEffect } from "react";
import "../Toggle.css";
import GroupToggle from "./GroupToggle";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { Location } from "history";
import { useLocation } from "react-router-dom";
import {getAuthorization} from "../../../../axios/AxiosAut";
import AddStaffToGroupTableData from "./AddStaffToGroupTableData";
import GroupsStaffTableData from "./GroupsStaffTableData";
import PermissionsTableData from "./PermissionsTableData";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setGroupDetails } from "../../../../redux/slices/group/groupSlice";
import { setAPIDetailsGroupTable } from "../../../../redux/slices/statistics/statisticSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "animate.css";

function GroupDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const ID = state;
  const [GroupsStaff, setGroupsStaff] = useState<any>();
  const [Toggle, setToggle] = useState("Staff");
  const [open, setOpen] = useState(false);
  const [OpenGroup, setOpenGroup] = useState(false);
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addmember = Permissions.find((o) => o.codename === "add_staff");
  const editgroup = Permissions.find(
    (o) => o.codename === "change_customgroups"
  );
  const deletegroup = Permissions.find(
    (o) => o.codename === "delete_customgroups"
  );

  const toggleHandler = () => {
    if (Toggle == "Permissions") {
      setToggle("Staff");
    } else {
      setToggle("Permissions");
    }
  };
  const GroupModelHandler = () => {
    setOpenGroup(true);
  };
  const EditGroupInitialValues = {
    name: GroupsStaff?.group_name,
    descriptions: GroupsStaff?.description,
  };
  const APIDetailsGroupTable = useSelector(
    (state) => state.statistics.APIDetailsGroupTable
  );
  const dispatch = useDispatch();
  const getGroupdata = () => {
    getAuthorization()
      .get("company/all_groups/")
      .then((res) => {
        // setGroups(res.data.result);
        dispatch(setAPIDetailsGroupTable(res.data.result));
      })
      .catch((err) => {
        console.log("Error in getting company groups", err);
      });
  };

  const HandleSubmitEditGroup = (values, onSubmitProps) => {
    console.log("values", values);
    getAuthorization()
      .patch(`company/group_edit/${ID}/`, values)
      .then((res) => {
        console.log("values", values);
        setOpen(false);
        onSubmitProps.setSubmitting(false);
        Swal.fire({
          position: "top-end",
          title: "Group Edited!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
        navigate("/dashboard/management/company-staff");
        getGroupdata();
      })
      .catch((err) => {
        console.log("Error in editing group", err);
        onSubmitProps.setSubmitting(false);
      });
  };
  const ModalHandler = () => {
    setOpen(true);
  };
  useEffect(() => {
    //Get staff of single group
    getAuthorization()
      .get(`company/group_staff/${ID}`)
      .then((res) => {
        setGroupsStaff(res.data);
        dispatch(setGroupDetails(res.data));
      })
      .catch((err) => {
        console.log("Error in getting company groups", err);
      });
  }, []);
  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              <h2 className="font-Montserrat text-xl font-bold text-black">
                Group Details
              </h2>
              <div className="border-b-2 border-blue-200 w-24"></div>
            </div>
          </div>
          <div>
            {!addmember === undefined || addmember?.codename === "add_staff" ? (
              <button
                type="button"
                onClick={ModalHandler}
                className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
              >
                Add Member
              </button>
            ) : null}
          </div>
        </div>
        <div className="flex flex-col space-y-2 w-1/2">
          <div className="mt-4">
            <div className="space-y-2">
              <div className="flex flex-row space-x-1">
                <h3 className="font-Roboto text-sm text-gray-300">Name:</h3>
                <p className="font-Roboto text-sm">
                  {GroupsStaff === undefined ? null : GroupsStaff.group_name}
                </p>
              </div>
              <div className="flex flex-row space-x-1">
                <h3 className="font-Roboto text-sm text-gray-300">
                  Description:
                </h3>
                <p className="font-Roboto text-sm">
                  {GroupsStaff === undefined ? null : GroupsStaff.description}
                </p>
              </div>
            </div>
          </div>
        </div>
        <GroupToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
      {console.log("ID", ID)}
      {Toggle == "Staff" ? (
        <>
        <GroupsStaffTableData
          Staff={GroupsStaff === undefined ? null : GroupsStaff.staff}
          ID={ID}
        />
         <div className="flex flex-row justify-center mt-6">
      {!deletegroup === undefined ||
        deletegroup?.codename === "delete_customgroups" ? (
        <button
          type="button"
          className="text-blue-200  font-Montserrat  bg-transparent hover:bg-blue-50   focus:outline-none  font-medium rounded-lg text-lg px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
        >
          <svg
            className="mr-2"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_663_5557)">
              <path
                d="M9.53671 2.82133L0.974129 11.2473L0 16L4.82797 15.0413L13.3912 6.61467L9.53671 2.82133ZM2.51255 12.75L1.93674 12.1833L9.48387 4.76667L10.059 5.33267L2.51255 12.75ZM3.87281 14.0887L3.297 13.522L10.8441 6.10533L11.4199 6.672L3.87281 14.0887ZM16.2581 3.79267L14.3505 5.67133L10.4953 1.87733L12.4029 0L16.2581 3.79267Z"
                fill="#1F78B4"
              />
            </g>
            <defs>
              <clipPath id="clip0_663_5557">
                <rect width="16.2581" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Delete Group
        </button>
 ) : null}
 
 {!editgroup === undefined ||
        editgroup?.codename === "change_customgroups" ? (
        <button
          type="button"
          onClick={GroupModelHandler}
          className="text-blue-200  font-Montserrat ml-auto bg-transparent hover:bg-blue-50   focus:outline-none  font-medium rounded-lg text-lg px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
        >
          <svg
            className="mr-2"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_663_5557)">
              <path
                d="M9.53671 2.82133L0.974129 11.2473L0 16L4.82797 15.0413L13.3912 6.61467L9.53671 2.82133ZM2.51255 12.75L1.93674 12.1833L9.48387 4.76667L10.059 5.33267L2.51255 12.75ZM3.87281 14.0887L3.297 13.522L10.8441 6.10533L11.4199 6.672L3.87281 14.0887ZM16.2581 3.79267L14.3505 5.67133L10.4953 1.87733L12.4029 0L16.2581 3.79267Z"
                fill="#1F78B4"
              />
            </g>
            <defs>
              <clipPath id="clip0_663_5557">
                <rect width="16.2581" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Edit Group
        </button>
         ) : null}
      </div>
        </>

      ) : (
        <PermissionsTableData id={ID} />
      )}
      <Transition.Root show={OpenGroup} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpenGroup}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-40 transition-opacity" />
            </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="container w-auto">
                          <div className="w-full">
                            <Dialog.Title
                              as="h2"
                              className="font-Montserrat text-xl font-bold text-black"
                            >
                              Edit group
                            </Dialog.Title>
                            <div className="border-b-2 border-blue-200 w-24"></div>
                          </div>
                        </div>
                      </div>
                      <Formik
                        initialValues={EditGroupInitialValues}
                        onSubmit={HandleSubmitEditGroup}
                        validateOnMount
                      >
                        <Form className="flex flex-col my-5 space-y-7">
                          <div className="flex flex-col">
                            <Field name="name">
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <div className="flex justify-center w-full">
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Group Name"
                                      ></input>
                                    </div>
                                    {meta.touched && meta.error ? (
                                      <div className="flex pt-1">
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      </div>
                                    ) : null}
                                  </>
                                );
                              }}
                            </Field>
                          </div>
                          <div className="flex flex-col">
                            <Field name="description">
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <div className="flex justify-center w-full">
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Description"
                                      ></input>
                                    </div>
                                    {meta.touched && meta.error ? (
                                      <div className="flex pt-1">
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      </div>
                                    ) : null}
                                  </>
                                );
                              }}
                            </Field>
                          </div>
                          <div className="flex justify-center w-full">
                            <Field>
                              {(props) => {
                                const { field, form, meta } = props;
                                const { isSubmitting } = form;
                                return (
                                  <>
                                    {!isSubmitting ? (
                                      <button
                                        type="submit"
                                        {...(form.isValid
                                          ? {
                                              className:
                                                "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                                            }
                                          : {
                                              disabled: true,
                                              className:
                                                "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                                            })}
                                      >
                                        Update Group
                                      </button>
                                    ) : (
                                      <button
                                        disabled
                                        className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                                      >
                                        <div className="flex items-center justify-center space-x-2 animate-pulse">
                                          <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                          <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                          <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                        </div>
                                      </button>
                                    )}
                                  </>
                                );
                              }}
                            </Field>
                          </div>
                        </Form>
                      </Formik>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition.Root>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-40 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
                <div className="bg-white">
                  <div className="sm:flex sm:items-start">
                    <div className="container w-auto">
                      <div className="w-full">
                        <Dialog.Title
                          as="h2"
                          className="font-Montserrat text-xl font-bold text-black px-4 pt-5"
                        >
                          Add Members
                          <div className="border-b-2 border-blue-200 w-24"></div>
                        </Dialog.Title>
                      </div>
                    </div>
                  </div>
                  <AddStaffToGroupTableData />
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default GroupDetails;
